module.exports = __webpack_public_path__ + "img/bravo.538f1037.gif";